import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export const useENO1Download = (options?: {
  onSuccess?: (data: void | File) => void;
  onError?: () => void;
}) => {
  return useMutation({
    mutationFn: async ({ fileId, getFile = false, forPlayground = false }: { fileId: number; getFile?: boolean, forPlayground?: boolean }) => {
      try {
        const response = await axios.get(`/data-set/eno1/download?dataSet=${fileId}${forPlayground ? `&forPlayground=${forPlayground}` : ''}`, {
          responseType: 'arraybuffer',
        });

        
        let fileName: string | null = null;
        
        // Try to extract the filename from the Content-Disposition header
        // In some browsers/configurations this might work despite CORS issues
        const contentDisposition = 
          response.headers['content-disposition'] || 
          response.headers['Content-Disposition'];
        
        
        if (contentDisposition) {
          // Match the filename in Content-Disposition header
          const filenameMatch = /filename[^;=\n]*=(['"]?)([^"';]+)\1/i.exec(contentDisposition);
          if (filenameMatch && filenameMatch[2]) {
            fileName = decodeURIComponent(filenameMatch[2]);
          }
        }
        
        // If we couldn't get the filename from the header, generate one
        if (!fileName) {
          // Extract the current date in YYYYMMDD format for filename
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const timestamp = String(date.getHours()).padStart(2, '0') + 
                            String(date.getMinutes()).padStart(2, '0') + 
                            String(date.getSeconds()).padStart(2, '0');
          
          // Format filename similar to what we saw in the browser: CHA_DKA_20241_00_20240507073652.csv
          fileName = `ENO1_Data_${year}${month}${day}_${timestamp}.csv`;
        }

        // If getFile is true, return a File object instead of triggering download
        if (getFile) {
          return new File([response.data], fileName, { type: 'text/csv' });
        }

        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading file:', error);
        throw error;
      }
    },
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
};
